/* ============================================================
   ZAC MENS — THEME JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── FIX HEADER GAP ──
     The announcement bar is in normal flow (~38px), the nav is position:fixed at top:0.
     #MainContent starts AFTER the announcement bar in flow, so we only need
     padding = navH - (how much of the announcement bar is still visible).
     As the user scrolls the announcement bar away, the padding grows to full navH.
  ── */
  (function fixHeaderGap() {
    var ann  = document.querySelector('.announcement');
    var nav  = document.querySelector('.zac-nav');
    var main = document.getElementById('MainContent');
    if (!nav || !main) return;

    var annH = ann ? ann.offsetHeight : 0;
    var navH = nav.offsetHeight || 58;

    function update() {
      annH = ann ? ann.offsetHeight : 0;
      navH = nav.offsetHeight || 58;
      var visibleAnn = Math.max(0, annH - window.scrollY);
      main.style.paddingTop = Math.max(0, navH - visibleAnn) + 'px';
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  })();

  /* ── OVERLAY (shared) ── */
  var overlay      = document.getElementById('ZacOverlay');
  var leftDrawer   = document.getElementById('ZacDrawerLeft');
  var cartDrawer   = document.getElementById('ZacCartDrawer');

  function openOverlay() { if (overlay) overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeOverlay() { if (overlay) overlay.classList.remove('open'); document.body.style.overflow = ''; }

  function openLeftDrawer() {
    if (!leftDrawer) return;
    leftDrawer.classList.add('open');
    leftDrawer.setAttribute('aria-hidden', 'false');
    openOverlay();
  }
  function closeLeftDrawer() {
    if (!leftDrawer) return;
    leftDrawer.classList.remove('open');
    leftDrawer.setAttribute('aria-hidden', 'true');
    closeOverlay();
  }
  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    openOverlay();
    loadCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    closeOverlay();
  }

  /* ── BURGER → LEFT DRAWER ── */
  var burgerBtn = document.getElementById('ZacBurger');
  if (burgerBtn) burgerBtn.addEventListener('click', openLeftDrawer);

  var drawerClose = document.getElementById('ZacDrawerClose');
  if (drawerClose) drawerClose.addEventListener('click', closeLeftDrawer);

  /* ── CART BUTTON → RIGHT DRAWER ── */
  var cartBtn = document.getElementById('ZacCartBtn');
  if (cartBtn) cartBtn.addEventListener('click', openCartDrawer);

  var cartClose = document.getElementById('ZacCartClose');
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);

  /* ── OVERLAY CLICK ── */
  if (overlay) overlay.addEventListener('click', function () {
    closeLeftDrawer();
    closeCartDrawer();
  });

  /* ── ESC KEY ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLeftDrawer(); closeCartDrawer(); closeDrawerSearch(); }
  });

  /* ── DRAWER SUB-ACCORDIONS ── */
  document.querySelectorAll('.zac-drawer-link--parent').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = btn.getAttribute('data-group');
      var sub = document.getElementById('ZacSub' + idx);
      var isOpen = btn.classList.contains('open');
      // Close all others
      document.querySelectorAll('.zac-drawer-link--parent').forEach(function (b) {
        b.classList.remove('open');
        var s = document.getElementById('ZacSub' + b.getAttribute('data-group'));
        if (s) s.style.display = 'none';
      });
      if (!isOpen && sub) {
        btn.classList.add('open');
        sub.style.display = 'block';
      }
    });
  });

  /* ── SEARCH INSIDE DRAWER ── */
  var drawerSearchPanel = document.getElementById('ZacDrawerSearch');
  var drawerSearchToggle = document.getElementById('ZacDrawerSearchBtn');
  var drawerSearchInput  = document.getElementById('ZacDrawerSearchInput');
  var drawerSearchResults = document.getElementById('ZacDrawerSearchResults');
  var searchTimer = null;

  function openDrawerSearch() {
    if (!drawerSearchPanel) return;
    drawerSearchPanel.style.display = 'block';
    if (drawerSearchInput) drawerSearchInput.focus();
  }
  function closeDrawerSearch() {
    if (!drawerSearchPanel) return;
    drawerSearchPanel.style.display = 'none';
    if (drawerSearchInput) drawerSearchInput.value = '';
    if (drawerSearchResults) drawerSearchResults.innerHTML = '';
  }

  /* Nav search button (outside drawer) */
  var navSearchBtn = document.getElementById('ZacSearchBtn');
  if (navSearchBtn) navSearchBtn.addEventListener('click', openLeftDrawer);

  if (drawerSearchToggle) drawerSearchToggle.addEventListener('click', openDrawerSearch);

  if (drawerSearchInput) {
    drawerSearchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = drawerSearchInput.value.trim();
      if (!q) { drawerSearchResults.innerHTML = ''; return; }
      drawerSearchResults.innerHTML = '<p style="padding:12px 0;color:#999;font-size:0.82rem;">Searching...</p>';
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              drawerSearchResults.innerHTML = '<p style="padding:12px 0;color:#999;font-size:0.82rem;">No results found.</p>';
              return;
            }
            var html = '';
            products.forEach(function (p) {
              var img = p.featured_image ? p.featured_image.url : '';
              var price = p.price ? '$' + parseFloat(p.price).toFixed(2).replace(/\.00$/, '') : '';
              html += '<a href="' + p.url + '" class="zac-search-result-item" style="display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid #f0ede8;text-decoration:none;color:inherit;">';
              if (img) html += '<img src="' + img + '" alt="' + p.title + '" loading="lazy" style="width:48px;height:60px;object-fit:cover;flex-shrink:0;">';
              html += '<div><div style="font-size:0.85rem;font-weight:600;color:#0f1923;">' + p.title + '</div>';
              if (price) html += '<div style="font-size:0.8rem;color:#b89c6e;margin-top:2px;">' + price + '</div>';
              html += '</div></a>';
            });
            drawerSearchResults.innerHTML = html;
          })
          .catch(function () {
            drawerSearchResults.innerHTML = '<p style="padding:12px 0;color:#999;font-size:0.82rem;">Could not load results.</p>';
          });
      }, 280);
    });
  }

  /* ── CART DRAWER LOADER ── */
  function loadCartDrawer() {
    var body   = document.getElementById('ZacCartBody');
    var footer = document.getElementById('ZacCartFooter');
    var subtotalEl = document.getElementById('ZacCartSubtotal');
    if (!body) return;
    body.innerHTML = '<p style="padding:24px 20px;color:#999;font-size:0.85rem;">Loading...</p>';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCountEl(cart.item_count);
        if (!cart.item_count) {
          body.innerHTML = '<p class="zac-cart-empty">Your bag is empty.</p>';
          if (footer) footer.style.display = 'none';
          return;
        }
        if (footer) footer.style.display = 'block';
        if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2).replace(/\.00$/, '');
        var html = '';
        cart.items.forEach(function (item) {
          html += '<div class="zac-cart-item" data-line-key="' + item.key + '">';
          if (item.image) html += '<img src="' + item.image + '" alt="' + item.title + '">';
          html += '<div class="zac-cart-item-info">';
          html += '<div class="zac-cart-item-title">' + item.product_title + '</div>';
          if (item.variant_title && item.variant_title !== 'Default Title') {
            html += '<div class="zac-cart-item-variant">' + item.variant_title + '</div>';
          }
          html += '<div class="zac-cart-item-price">$' + (item.line_price / 100).toFixed(2).replace(/\.00$/, '') + '</div>';
          html += '<div class="zac-cart-item-footer">';
          html += '<div class="qty-stepper zac-qty-stepper">';
          html += '<button type="button" class="qty-btn" data-key="' + item.key + '" data-delta="-1">&#8722;</button>';
          html += '<input type="number" class="qty-input zac-cart-qty" value="' + item.quantity + '" min="1" max="99" data-key="' + item.key + '" readonly>';
          html += '<button type="button" class="qty-btn" data-key="' + item.key + '" data-delta="1">+</button>';
          html += '</div>';
          html += '<button class="zac-cart-item-remove" data-line-key="' + item.key + '" style="background:none;border:none;cursor:pointer;font-size:0.72rem;color:#999;padding:0;text-transform:uppercase;letter-spacing:1px;">Remove</button>';
          html += '</div>';
          html += '</div></div>';
        });
        body.innerHTML = html;
      })
      .catch(function () {
        body.innerHTML = '<p style="padding:24px 20px;color:#999;font-size:0.85rem;">Could not load cart.</p>';
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('zac-cart-item-remove')) {
      var key = e.target.getAttribute('data-line-key');
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        loadCartDrawer();
        updateCartCountEl(cart.item_count);
      })
      .catch(function () {});
    }
  });

  /* ── Cart drawer quantity stepper ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn[data-key]');
    if (!btn) return;
    var key   = btn.dataset.key;
    var delta = parseInt(btn.dataset.delta);
    var input = document.querySelector('.zac-cart-qty[data-key="' + key + '"]');
    if (!input) return;
    var newQty = Math.max(1, (parseInt(input.value) || 1) + delta);
    input.value = newQty;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartCountEl(cart.item_count);
      var subtotalEl = document.getElementById('ZacCartSubtotal');
      if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2).replace(/\.00$/, '');
    })
    .catch(function () {});
  });

  /* ── 1. STICKY HEADER + TRANSPARENT NAV ON HOMEPAGE ── */
  var nav = document.querySelector('nav');
  var isHomePage = document.body.classList.contains('home-page');

  if (nav) {
    if (isHomePage) nav.classList.add('nav-transparent');
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        nav.classList.add('scrolled');
        nav.classList.remove('nav-transparent');
      } else {
        nav.classList.remove('scrolled');
        if (isHomePage) nav.classList.add('nav-transparent');
      }
    }, { passive: true });
  }

  /* ── (legacy mega menu - kept for backward compat) ── */
  var shopTrigger  = document.getElementById('shopTrigger');
  var megaMenu     = document.getElementById('megaMenu');
  var megaBackdrop = document.getElementById('megaBackdrop');
  var megaCloseTimer = null;
  if (shopTrigger) {
    shopTrigger.addEventListener('mouseenter', function () {
      clearTimeout(megaCloseTimer);
      if (shopTrigger) shopTrigger.classList.add('open');
      if (megaMenu) megaMenu.classList.add('open');
      if (megaBackdrop) megaBackdrop.classList.add('open');
    });
    shopTrigger.addEventListener('mouseleave', function () {
      megaCloseTimer = setTimeout(function () {
        if (shopTrigger) shopTrigger.classList.remove('open');
        if (megaMenu) megaMenu.classList.remove('open');
        if (megaBackdrop) megaBackdrop.classList.remove('open');
      }, 120);
    });
  }

  /* ── 5. PRODUCT IMAGE GALLERY ── */
  const mainImg = document.getElementById('productMainImage');
  const thumbs = document.querySelectorAll('.gallery-thumb');

  if (mainImg && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.getAttribute('data-full') || thumb.src;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ── 4. SIZE SELECTOR ── */
  const sizeBtns = document.querySelectorAll('.size-btn');
  const variantIdInput = document.getElementById('variantId');

  if (sizeBtns.length) {
    sizeBtns.forEach(function (btn) {
      if (btn.classList.contains('unavailable')) return;
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        if (variantIdInput) {
          variantIdInput.value = btn.getAttribute('data-variant-id') || '';
        }
        // Update price display if variant has different price
        var variantPrice = btn.getAttribute('data-price');
        var variantCompare = btn.getAttribute('data-compare-price');
        var priceEl = document.getElementById('productPriceDisplay');
        if (priceEl && variantPrice) {
          if (variantCompare && parseInt(variantCompare) > parseInt(variantPrice)) {
            priceEl.innerHTML = '<span class="compare">' + formatMoney(variantCompare) + '</span><span class="sale">' + formatMoney(variantPrice) + '</span>';
          } else {
            priceEl.innerHTML = formatMoney(variantPrice);
          }
        }
      });
    });
  }

  function formatMoney(cents) {
    var amount = parseInt(cents) / 100;
    return '$' + amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── 5. ADD TO CART VIA AJAX ── */
  var addToCartForm = document.getElementById('addToCartForm');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = addToCartForm.querySelector('.add-to-cart-btn');
      var variantInput = document.getElementById('variantId');

      if (!variantInput || !variantInput.value) {
        // Try to auto-select first available variant
        var firstAvailable = document.querySelector('.size-btn:not(.unavailable)');
        if (firstAvailable) {
          firstAvailable.click();
        } else {
          alert('Please select a size.');
          return;
        }
      }

      var variantId = variantInput ? variantInput.value : '';
      if (!variantId) {
        alert('Please select a size.');
        return;
      }

      var originalText = btn ? btn.textContent : 'Add to Cart';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.id) {
          updateCartCount();
          openCartDrawer();
          if (btn) {
            btn.textContent = 'Added!';
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = originalText;
            }, 1800);
          }
        } else {
          throw new Error(data.description || 'Error adding to cart');
        }
      })
      .catch(function (err) {
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
        alert(err.message || 'Could not add to cart. Please try again.');
      });
    });
  }

  /* ── 6. UPDATE CART COUNT ── */
  function updateCartCountEl(count) {
    var el = document.getElementById('ZacCartCount');
    if (!el) return;
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCountEl(cart.item_count);
        // also update any legacy .cart-count elements
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  // Update count on page load
  updateCartCount();

  /* ── 7. PRODUCT TAB ACCORDION ── */
  var tabBtns = document.querySelectorAll('.tab-btn');
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-tab');
      var content = document.getElementById(targetId);
      var isOpen = btn.classList.contains('open');

      // Close all tabs
      tabBtns.forEach(function (b) {
        b.classList.remove('open');
        var c = document.getElementById(b.getAttribute('data-tab'));
        if (c) c.classList.remove('open');
      });

      // Open clicked tab if it was closed
      if (!isOpen && content) {
        btn.classList.add('open');
        content.classList.add('open');
      }
    });
  });

  /* ── 8. CART QUANTITY +/- BUTTONS ── */
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('qty-btn')) {
      var control = e.target.closest('.qty-control');
      if (!control) return;
      var input = control.querySelector('.qty-input');
      if (!input) return;
      var current = parseInt(input.value) || 1;
      var isPlus = e.target.getAttribute('data-action') === 'plus';
      var newVal = isPlus ? current + 1 : Math.max(1, current - 1);
      input.value = newVal;

      // If on cart page, update line item
      var lineKey = control.getAttribute('data-line-key');
      if (lineKey) {
        updateCartItem(lineKey, newVal, control);
      }
    }
  });

  function updateCartItem(key, quantity, control) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateCartCount();
      // Update subtotal display
      var subtotalEl = document.getElementById('cartSubtotal');
      if (subtotalEl && cart.total_price !== undefined) {
        subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
      }
      // If quantity is 0, remove the item row
      if (quantity === 0 && control) {
        var row = control.closest('.cart-item');
        if (row) row.remove();
      }
    })
    .catch(function () {});
  }

  /* ── 9. CART REMOVE ITEM ── */
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('cart-item-remove')) {
      var key = e.target.getAttribute('data-line-key');
      var row = e.target.closest('.cart-item');
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (row) row.remove();
        updateCartCount();
        var subtotalEl = document.getElementById('cartSubtotal');
        if (subtotalEl) {
          subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
        }
        if (cart.item_count === 0) {
          var itemsEl = document.getElementById('cartItems');
          var emptyEl = document.getElementById('cartEmpty');
          if (itemsEl) itemsEl.style.display = 'none';
          if (emptyEl) emptyEl.style.display = 'block';
        }
      })
      .catch(function () {});
    }
  });

  /* ── 10. COLLECTION FILTER BUTTONS ── */
  var filterBtns = document.querySelectorAll('.filter-btn');
  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var tag = btn.getAttribute('data-tag');
      var cards = document.querySelectorAll('.product-card[data-tags]');
      cards.forEach(function (card) {
        if (!tag || tag === 'all') {
          card.style.display = '';
        } else {
          var tags = (card.getAttribute('data-tags') || '').toLowerCase();
          card.style.display = tags.indexOf(tag.toLowerCase()) > -1 ? '' : 'none';
        }
      });
    });
  });

  /* ── 11. WISHLIST BUTTON ── */
  var wishlistBtn = document.querySelector('.wishlist-btn');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function () {
      var productId = wishlistBtn.getAttribute('data-product-id');
      var key = 'zacmens_wishlist';
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      var idx = list.indexOf(productId);
      if (idx > -1) {
        list.splice(idx, 1);
        wishlistBtn.textContent = '+ Save to Wishlist';
      } else {
        list.push(productId);
        wishlistBtn.textContent = '✓ Saved to Wishlist';
      }
      localStorage.setItem(key, JSON.stringify(list));
    });

    // Check if already wishlisted
    var productId = wishlistBtn.getAttribute('data-product-id');
    if (productId) {
      var list = JSON.parse(localStorage.getItem('zacmens_wishlist') || '[]');
      if (list.indexOf(productId) > -1) {
        wishlistBtn.textContent = '✓ Saved to Wishlist';
      }
    }
  }

});
